const isLiveType = type => type === 'LIVE' || type === 'Live'
const isNonTrusteeType = type => type === 'NON_TRUSTEE'
const isOnlineType = type => type === 'ONLINE' || type === 'Online'
const isOnLocationSetting = setting =>
  setting === 'ONLOCATION' || setting === 'On Location'
const isThirdPartyType = type => type === 'THIRD_PARTY'
const isTrusteeType = type => type === 'TRUSTEE'

const canShowAddress = (isLive, isThirdParty, isOnLocation, isNonTrustee) =>
  (isLive || isThirdParty) && (isNonTrustee || !isOnLocation)

const canShowAddressOnLocation = (isOnLocation, isTrustee) =>
  isOnLocation && isTrustee

const buildRedirectVenueUrl = (eventId, venueId) => {
  const alternativeRoute = `alternativeRoute=/schedule/events/${eventId}/edit`
  const url = venueId
    ? `/schedule/venues/${venueId}/edit?${alternativeRoute}`
    : `/schedule/venues/create?eventId=${eventId}&${alternativeRoute}`
  return url
}
const isUrlEmpty = (_, value) => {
  return ['http://', 'https://'].includes(value)
}

const timeout = wait => new Promise(resolve => setTimeout(resolve, wait))

export {
  isLiveType,
  isNonTrusteeType,
  isOnlineType,
  isOnLocationSetting,
  isThirdPartyType,
  isTrusteeType,
  buildRedirectVenueUrl,
  canShowAddress,
  canShowAddressOnLocation,
  timeout,
  isUrlEmpty,
}
